import { CardHeader } from "reactstrap";
import { Btn, H4 } from "../../../../AbstractElements";
import IconComponent from "../../../../CommonElements/IconComponent";

export interface IEmployeeCardHeaderProps {
  headClass?: string;
  subClass?: string;
  titleClass?: string;
  title?: string;
  iconClassName?: string;
  iconOnClick?: () => void;
  showEditInfo?: boolean;
}

const EmployeeCardHeader = ({
  title,
  headClass,
  subClass,
  titleClass,
  iconClassName,
  iconOnClick,
  showEditInfo,
}: IEmployeeCardHeaderProps) => {
  return (
    <CardHeader className={headClass}>
      <div className={`header-top ${subClass}`}>
        <H4 className={titleClass}>{title}</H4>
        {showEditInfo && (
          <Btn style={{ border: "none" }} onClick={iconOnClick}>
            <IconComponent className={iconClassName} />
          </Btn>
        )}
      </div>
    </CardHeader>
  );
};

export default EmployeeCardHeader;
